




































































































































import { Component, Watch } from 'vue-property-decorator';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import { Funcionalidades } from '@/config/funcionalidades';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import CertificadosModalEmitir from './CertificadosModalEmitir.vue';

import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';
import Confirmation from '@/components/Confirmation.vue';

import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';

import {
  ParamsApi,
  ClearParam,
  MsgParam,
  IdParams,
  DataApi,
  FiltersApi,
} from './models/EdicionCertificados.model';

import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  ColDef,
  ColumnApi,
  CellClickedEvent,
} from 'ag-grid-community';

import { fetchEdicionCertificados } from './fetchEdicionCertificados';
import PopUpGeneratedReports from './PopUpGeneratedReports.vue';

@Component({
  components: {
    Confirmation,
    MantenedorGridSinCodigo,
    DatePicker,
    FormFieldsContainer,
    CertificadosModalEmitir,
  },
})
export default class EdicionCertificadosBase extends ComponenteBase {
  readonly funcionalidad: Funcionalidades = Funcionalidades.Atenciones;
  readonly accionesTotales: PermisoAccion[] = [];

  columnApi: any = null;
  gridOptions: GridOptions = null;
  gridEvent: any = null;
  gridApi: GridApi = null;
  columnDefs: ColDef[] = [];
  dataList: DataApi[] = [];

  dialogPopUp: boolean = false;
  activateChangeFn: boolean = false;
  showModalViewDetail: boolean = false;
  showPopUpReport: boolean = false;
  filtro: string = '';

  now: string = moment().format('YYYY-MM-DD');
  msgReport: string = '';

  numConfirmations: number = 0;

  confirmationData: Record<string, string> = {
    atenumero: '',
    ateestado: '',
    title: '',
    msgConfirmation: '',
  };

  data: DataApi = {};
  filter: FiltersApi[] = [
    { configlbl: 'Activo', configval: true },
    { configlbl: 'Inactivo', configval: false },
  ];
  objectParam: ParamsApi = {
    start_date: moment().subtract(1, 'month'),
    end_date: moment(),
    folio: '',
  };
  currentObjectParam: ParamsApi = {};
  timeout: { timeout: number } = { timeout: 3000 };
  accion: boolean;
  motivo_desactivacion: string = '';
  mostrarHijo: boolean = false;
  constructor() {
    super();
    this.columnDefs = this.colsGrid();
    this.generaActionsEvent();
    this.gridOptions = {
      columnDefs: this.columnDefs,
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      overlayNoRowsTemplate: 'No hay filas para mostrar',
      onGridReady: this.handleMainGridReady,
    };
  }
  generaActionsEvent() {}
  colsGrid(): ColDef[] {
    const cols = [
      { field: 'Folio', id: 'folio' },
      { field: 'Certificado', id: 'url' },
      { field: 'Fecha Emisión', id: 'fecha_creacion' },
      { field: 'Fecha Vencimiento', id: 'fecha_vencimiento' },
      { field: 'Certificado Activo', id: 'certificado_activo' },
      { field: 'Fecha Actualización', id: 'fecha_actualizacion' },
      { field: 'Usuario Edita', id: 'usuario_edita' },
      { field: 'Motivo', id: 'motivo' },
    ];

    return cols.map(col => {
      let cb = null;
      if (col.id === 'certificado_activo') {
        cb = {
          cellRenderer: (params: any) => this.iconState(params.value),
        };
      }
      if (col.id === 'folio') {
        cb = {
          headerCheckboxSelection: true,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
        };
      }
      if (col.id === 'url') {
        cb = {
          cellRenderer: (params: any) =>
            `<a href="${params.value}" target="_blank">Ver certificado</a>`,
        };
      }
      return {
        headerName: col.field,
        field: col.id,
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 220,
        minWidth: 100,
        ...cb,
      };
    });
  }
  iconState(state: string): string {
    const val = state.toLowerCase();
    return `<i class="material-icons" style="width: 15px; height: 15px;margin-top: 7px; border-radius: 50%; background: ${
      val === 'activo' ? 'rgb(42 255 78)' : 'rgb(255 58 58)'
    }"></i>
     <a style="color: #4f4f4f; position: absolute; margin-top: 0%; margin-left: 3%">${state}</a>`;
  }

  async handleMainGridReady(event: GridReadyEvent): Promise<void> {
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    this.reloadGrid({});
  }

  async reloadGrid({ clear = false }: ClearParam): Promise<void> {
    clear && this.clear();
    this.dataList = await this.getAll();
    this.gridApi.setRowData(this.dataList);
    this.gridApi.setDomLayout('autoHeight');
  }

  handleShowPopUp(confirmation: boolean): void {
    if (!confirmation) {
      this.mostrarHijo = false;
      return this.clearDataPopUp();
    }
    this.numConfirmations++;
    this.validateSatateValue({
      numConfirmations: this.numConfirmations,
    });
  }

  validateSatateValue({ numConfirmations }: IdParams): void {
    this.envia_cambio_estado_certificados({
      numConfirmations,
    });
  }
  envia_cambio_estado_certificados(params: any): void {
    if (params.numConfirmations === 1) {
      this.dialogPopUp = false;
      this.mostrarHijo = this.accion ? false : true;
      const mensaje = this.accion ? 'activar' : 'desactivar';
      this.confirmationData.title = `Edición de Certificados`;
      this.confirmationData.msgConfirmation = `¿Está seguro que desea ${mensaje} los certificados seleccionados?`;
      setTimeout(() => (this.dialogPopUp = true), 800);
      return;
    }
    if (params.numConfirmations === 2) {
      this.updateEstado();
      this.clearDataPopUp();
      this.mostrarHijo = false;
      return;
    }
    this.mostrarHijo = false;
    this.clearDataPopUp();
  }

  cambiar_estado_certificados(estado: boolean): void {
    const selectedRows = this.gridApi.getSelectedRows();
    if (selectedRows.length === 0) {
      this.$snotify.error('Debe seleccionar al menos un certificado', {
        ...this.timeout,
      });
      return;
    }
    this.accion = estado;
    const mensaje = estado ? 'activación' : 'desactivación';
    this.confirmationData = {
      title: `Confirmación edición de certificados`,
      msgConfirmation: `¿Confirma que deseas continuar con la ${mensaje} de los certificados seleccionados?`,
    };
    this.dialogPopUp = true;
  }
  handleFilters(): void {
    if (
      this.objectParam.folio &&
      this.objectParam.folio !== this.currentObjectParam.folio
    ) {
      this.activateChangeFn = false;
      return;
    }
    if (this.objectParam.folio === this.currentObjectParam.folio) {
      this.reloadGrid({});
      return;
    }
    if (this.activateChangeFn || this.objectParam.folio === null) {
      this.objectParam.folio = '';
      this.reloadGrid({});
      return;
    }
  }

  handleSearchFilter(): void {
    if (
      this.objectParam.folio &&
      this.objectParam.folio !== this.currentObjectParam.folio
    ) {
      this.activateChangeFn = false;
      this.currentObjectParam = { ...this.objectParam };
      this.reloadGrid({});
      return;
    }
    this.activateChangeFn = true;
    this.currentObjectParam = { ...this.objectParam };
    this.reloadGrid({});
  }

  handleViewDetail() {
    this.showModalViewDetail = true;
  }

  handleClosedModal() {
    this.handleSearchFilter();
    this.showModalViewDetail = false;
  }

  handleCloseReport(): void {
    this.showPopUpReport = false;
    this.msgReport = '';
  }

  preventMinusKey(event: KeyboardEvent): void {
    const { key } = event;
    // Permitir tecla de retroceso
    if (['Backspace', 'Shift', 'ArrowLeft', 'ArrowRight'].includes(key)) {
      return;
    }

    // Permitir solo números enteros positivos
    if (key === 'Dead') {
      event.preventDefault();
      return;
    }

    const isValid = /^\d+$/.test(key);

    if (!isValid) {
      event.preventDefault();
    }
  }

  clear(): void {
    Object.keys(this.objectParam).forEach(
      key =>
        ((this.objectParam[key as keyof ParamsApi] as any) =
          key === 'start_date'
            ? (moment().subtract(1, 'month') as any)
            : key === 'end_date'
            ? moment()
            : '')
    );
    this.activateChangeFn = false;
    this.currentObjectParam = {};
  }

  clearDataPopUp(): void {
    this.dialogPopUp = false;
    this.numConfirmations = 0;
    Object.keys(this.confirmationData).forEach(
      key => (this.confirmationData[key] = '')
    );
  }

  validateError({ msg }: MsgParam): void {
    if (msg === 'Request failed with status code 500') {
      this.$snotify.error(
        'El servicio no se encuentra disponible, por favor intente más tarde',
        { ...this.timeout }
      );
    } else {
      this.$snotify.error(
        'Ha ocurrido un error inesperado, por favor intente más tarde',
        { ...this.timeout }
      );
    }
    throw msg;
  }

  async getAll(): Promise<DataApi[]> {
    this.loadingService.showLoading();
    const self = this;
    return await fetchEdicionCertificados({ body: { ...this.objectParam } })
      .then(response => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA, LISTA } = response.data;

        if (CODIGO_RESPUESTA != '1') {
          self.$snotify.error(MENSAJE_RESPUESTA, { ...self.timeout });
          return [];
        }
        return LISTA;
      })
      .catch((err: Error) => {
        err instanceof Error && self.validateError({ msg: err.message });
        throw err;
      })
      .finally(() => self.loadingService.hideLoading());
  }

  async updateEstado(): Promise<void> {
    this.loadingService.showLoading();
    const self = this;
    let body: { [key: string]: any } = {
      usuario: this.getUserId(),
      certificados: this.gridApi.getSelectedRows(),
      estado: this.accion,
    };
    if (this.accion === false) {
      body = { ...body, motivo: this.motivo_desactivacion };
    }
    return await fetchEdicionCertificados({
      endpoint: 'update_certificado',
      body: body,
    })
      .then(response => {
        const { MENSAJE_RESPUESTA, CODIGO_RESPUESTA } = response.data;

        if (CODIGO_RESPUESTA != '1') {
          self.$snotify.error(MENSAJE_RESPUESTA, { ...self.timeout });
        } else {
          self.$snotify.success(MENSAJE_RESPUESTA, { ...self.timeout });
        }
        self.reloadGrid({});
      })
      .catch(
        (err: Error) =>
          err instanceof Error && self.validateError({ msg: err.message })
      )
      .finally(() => self.loadingService.hideLoading());
  }
  getUserId(): number {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;
    return parseInt(id);
  }
  @Watch('objectParam.start_date')
  startDateChange() {
    if (this.objectParam.start_date > this.objectParam.end_date) {
      this.objectParam.end_date = this.objectParam.start_date;
    }
    this.handleFilters();
  }

  @Watch('objectParam.end_date')
  endDateChange() {
    if (this.objectParam.end_date < this.objectParam.start_date) {
      this.objectParam.start_date = this.objectParam.end_date;
    }
    this.handleFilters();
  }
}
